import { Reveal } from "./Reveal";
import { TEAM } from "../lib/blogs";

export const Team = () => (
  <section id="team" className="border-t border-[#262626] bg-[#0A0A0A]" data-testid="team-section">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 lg:py-36">
      <div className="grid lg:grid-cols-12 gap-8 items-end mb-16">
        <Reveal className="lg:col-span-8">
          <span className="overline">The Team</span>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] mt-5 text-[#F7F5F2] text-balance">
            Counsel who stand <span className="italic text-[#C8A24B]">beside you</span>.
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-4">
          <p className="text-[#8C8C8C] leading-relaxed">
            A committed team supporting Advocate Manpreet Singh Bhatti across research, drafting and courtroom advocacy in criminal matters.
          </p>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-2 gap-px bg-[#262626] border border-[#262626]">
        {TEAM.map((m, i) => (
          <Reveal key={m.name} delay={i * 0.1}>
            <div className="h-full bg-[#0A0A0A] hover:bg-[#121212] transition-colors duration-500 flex flex-col sm:flex-row" data-testid={`team-member-${i}`}>
              <div className="relative w-full sm:w-[44%] shrink-0 aspect-[4/5] overflow-hidden">
                <img
                  src={m.photo}
                  alt={m.name}
                  loading="lazy"
                  className="w-full h-full object-cover object-top grayscale-[0.2] hover:grayscale-0 transition-all duration-700"
                />
                <div className="absolute inset-0 ring-1 ring-inset ring-[#262626]" />
              </div>
              <div className="p-8 lg:p-10 flex flex-col">
                <span className="font-mono text-xs text-[#C8A24B]">/ 0{i + 1}</span>
                <h3 className="font-serif text-2xl lg:text-3xl mt-4 text-[#F7F5F2]">{m.name}</h3>
                <p className="overline mt-2">{m.role}</p>
                <p className="text-[#8C8C8C] leading-relaxed mt-5 text-sm">{m.bio}</p>
                <div className="flex flex-wrap gap-2 mt-6 pt-6 border-t border-[#262626]">
                  {m.tags.map((t) => (
                    <span key={t} className="text-xs font-mono text-[#8C8C8C] border border-[#262626] rounded-full px-3 py-1.5">
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
